<div class="m-checkbox"
     :class="{ 'm--is-checkbox-left': hasCheckboxLeft,
                'm--is-checkbox-right': !hasCheckboxLeft,
                'm--is-checkbox-top': isAlignTop,
                'm--is-checked': propValue,
                'm--is-disabled': isDisabled,
                'm--is-indeterminate': propIndeterminate,
                'm--is-readonly': readonly,
                'm--is-focus': isFocus,
                'm--has-error': hasError,
                'm--is-valid': isValid,
                'm--has-validation-message': hasValidationMessage }">
    <input v-if="!readonly"
           :id="id"
           class="m-checkbox__hidden"
           :indeterminate.prop="propIndeterminate"
           :disabled="isDisabled"
           v-model="propValue"
           @click="onClick"
           @focus="setFocus(true)"
           @blur="setFocus(false)"
           ref="checkbox"
           type="checkbox">
    <input :id="id"
           v-if="readonly"
           :value="propValue"
           type="hidden" />
    <label class="m-checkbox__wrap"
           :for="id"
           :aria-label="ariaLabel">
        <span class="m-checkbox__input"
              aria-hidden="true">
            <span class="m-checkbox__input__icon"></span>
        </span>
        <div v-if="$slots.default"
             class="m-checkbox__label">
            <slot></slot>
        </div>
    </label>
    <m-validation-message class="m-checkbox__message"
                          :disabled="isDisabled"
                          :error="hasError"
                          :error-message="errorMessage"
                          :valid-message="validMessage"
                          :helper-message="helperMessage"
                          ref="validation"></m-validation-message>
</div>
